import JSBI from 'jsbi'

// exports for external consumption
export type BigintIsh = JSBI | bigint | string

export enum ChainId {
  // MAINNET = 56,
  // TESTNET = 97
  MAINNET = 10000,
  TESTNET = 10001
}

export enum TradeType {
  EXACT_INPUT,
  EXACT_OUTPUT
}

export enum Rounding {
  ROUND_DOWN,
  ROUND_HALF_UP,
  ROUND_UP
}

//export const FACTORY_ADDRESS = '0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73' // todo xxxxx
//export const FACTORY_ADDRESS = '0x0A176F6B1db32e9e6088655Ca7d1Bdb54e171260'
//export const FACTORY_ADDRESS = '0xfF4787171dDD8dE3aC32E60faf393A25EA1Eb745'
//export const FACTORY_ADDRESS = '0xa08a60Bfbf19386E746A22395af5C92104fD8179'
//export const FACTORY_ADDRESS = '0xd8c66A5d9e658f5C09616F925657Fe92Fc02AB1B' // mainet with bad apir
export const FACTORY_ADDRESS = '0x3dC4e6aC26df957a908cfE1C0E6019545D08319b'

//export const INIT_CODE_HASH = '0x00fb7f630766e6a796048ea87d01acd3068e8ff67d078148a3fa3f4a84f69bd5'  // todo xxxxx
//export const INIT_CODE_HASH = '0x371699f3d891c68243834b331cca09c833ef2540dfa8c6cb4b518460469854f3'
//export const INIT_CODE_HASH = '0xee596446c333129b471afa3d3885ec8060a5078097154166641f2242e5e35e8d'
//export const INIT_CODE_HASH = '0xc4b32a80be8329a18ddd1c96c34bb258bc5bc68cac9ee7eebd081cd58a33cfb3'
//export const INIT_CODE_HASH = '0xa8a3230704cf73cb4345fa5ebd48e0bd01b0f9ed92d203db29b9eaf024bd08fa' // mainet
export const INIT_CODE_HASH = '0xa8a3230704cf73cb4345fa5ebd48e0bd01b0f9ed92d203db29b9eaf024bd08fa'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const TWO = JSBI.BigInt(2)
export const THREE = JSBI.BigInt(3)
export const FIVE = JSBI.BigInt(5)
export const TEN = JSBI.BigInt(10)
export const _100 = JSBI.BigInt(100)
export const FEES_NUMERATOR = JSBI.BigInt(9975)
export const FEES_DENOMINATOR = JSBI.BigInt(10000)

export enum SolidityType {
  uint8 = 'uint8',
  uint256 = 'uint256'
}

export const SOLIDITY_TYPE_MAXIMA = {
  [SolidityType.uint8]: JSBI.BigInt('0xff'),
  [SolidityType.uint256]: JSBI.BigInt('0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff')
}
